import { render, staticRenderFns } from "./CallRecordPanel.vue?vue&type=template&id=e4b43e7e&scoped=true&"
import script from "./CallRecordPanel.vue?vue&type=script&lang=js&"
export * from "./CallRecordPanel.vue?vue&type=script&lang=js&"
import style0 from "./CallRecordPanel.vue?vue&type=style&index=0&id=e4b43e7e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b43e7e",
  null
  
)

export default component.exports